<app-spinner [name]="'multi-org'"></app-spinner>

<!-- Display Required Label if showRequired is true -->
@if (showRequired()) {
  <div class="font-16 semibold mtb-10 flex justify-end">
    <font class="font-required">*(Required)</font>
  </div>
}

<!-- Informative Text based on Role Admin Status -->
<div class="mb-10 mt-20">
  @if (isRoleAdmin()) {
    <span>
      You are a role administrator for multiple organizations. Please select an organization to manage its roles.
    </span>
  }
  @if (!isRoleAdmin()) {
    <span>
      You are associated with multiple organizations, please select an organization to request a role.
    </span>
  }
</div>

<!-- Role Selection and Organization Selection Section -->
<div class="border-bottom border-gray-600 mb-20 pb-10">
  <div class="inline-text-field-container even-cols flex-row gap-20" style="width: 50%;">

    <!-- Organization Selection Dropdown -->
    <ng-container>
      <div class="select-container chevron border-bottom border-gray-600  width-50">
        <select class="ds-select-field rounded-4 hover-gray-300" required [(ngModel)]="selectedOrganization"
          (change)="onChangeOrg()" name="selectOrganization">
          @for (org of organizations; track org) {
            <option [ngValue]="org">
              {{org.irn}} - {{org.orgName}}
            </option>
          }
        </select>
        <label class="ds-floating-label">*Select Organization</label>
      </div>
    </ng-container>
  </div>
</div>
